/* unplugin-vue-components disabled */import script from "./ContentmentList.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentmentList.vue?vue&type=script&setup=true&lang=js"

import "./ContentmentList.vue?vue&type=style&index=0&id=e8e1351a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8e1351a"]])

export default __exports__